import type { LatLng } from '@/types/structs'

/* Port of queryCurrentUserLocation / getCurrentUserLocation
 * (flutter_flow_util.dart + Geolocator).
 *
 * queryCurrentUserLocation returns null unless BOTH coords are non-zero
 * (`lat != 0 && lng != 0` — the OR-invalid rule); any error / denied
 * permission also yields null. getCurrentUserLocation then substitutes the
 * defaultLocation — the app always passes LatLng(0,0) as the sentinel.
 *
 * The Dart version has a `cached` parameter whose cache is WRITTEN but never
 * READ (both call sites omit it) — every call is a real fix. Not ported. */

async function queryCurrentUserLocation(): Promise<LatLng | null> {
  if (!('geolocation' in navigator)) return null
  try {
    const pos = await new Promise<GeolocationPosition>((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
      }),
    )
    const { latitude, longitude } = pos.coords
    return latitude !== 0 && longitude !== 0
      ? { lat: latitude, lng: longitude }
      : null
  } catch {
    return null
  }
}

export async function getCurrentUserLocation(defaultLocation: LatLng): Promise<LatLng> {
  return (await queryCurrentUserLocation()) ?? defaultLocation
}
